<template>
    <v-page-data-table
            title="角色管理"
            key-name="id"
            :fields="fields"
            ref="producer"
            @create="onDetail"
            :height="535"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="ROLE_DELETE"
            query-api="ROLE_QUERY">

        <template v-slot:roleName="{item}">
            <v-link-text :text="item.roleName" @click="onDetail(item)"></v-link-text>
        </template>

        <template v-slot:state="{item}">
            {{item.state==0?'禁用':'启用'}}
        </template>
        <template v-slot:sex="{item}">
            {{item.sex=='M'?'男':'女'}}
        </template>
    </v-page-data-table>
</template>

<script>
    import FndRoleQueryFields from "./fields/FndRoleQuery";
    import _ from 'lodash';

    export default {
        name: "ProducerQuery",
        data() {
            return {
                fields: FndRoleQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '新建角色',
                        color: 'primary',
                        icon: "mdi-account-group",
                        action: 'create'
                    }
                ],
                currentItem: {
                    id: null,
                    name: null,
                    handler: null,
                    status: null,
                    exeCount: null,
                    type: null,
                    jobType: null,
                    jobInterval: null,
                    jobIntervalUnit: null,
                    queue: null,
                    lastExecuteTime: null,
                    lastExecuteResult: null,
                    startDate: null,
                    endDate: null,
                    jobExecuteTime: null,
                    parameter: null
                }
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("roleDetail", {id: id});
            }
        }
    }
</script>
